import React from 'react';
import SharingSetupModal from '../SharingSetupModal';
import type { SharingSetupProps } from '../types';
import { volunteeringInjectableFields } from './injectableFields';
import defaultShareFormYaml from './default_share_form.yaml?raw';

/**
 * Volunteering share-message form editor: the shared shell seeded with the volunteering
 * form.
 */
const SharingSetup: React.FC<SharingSetupProps> = props => (
  <SharingSetupModal
    {...props}
    defaultShareFormYaml={defaultShareFormYaml}
    injectableFields={volunteeringInjectableFields}
  />
);

export default SharingSetup;
